import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

import { useNav } from '../../components/hooks'
import { TableCustom, SectionHeading, Select } from '../../components/common';
import { APIS } from '../../config/apis';
import { ALERT_TYPE, OPERATION_MODE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { ServerRequest } from '../../utils/apiweb';
import { DistinctArray, GetTitleFromField } from '../../utils/helpers';

import './index.scss';
import { useAccess } from '../../components/hooks/useAccess';


function EntidadesView() {

    const navigate = useNav()
    const location = useLocation()
    const navigationType = useNavigationType()

    //hooks
    const [state, setState] = useState({
        list: [],
        loading: false
    });

    const [grupo, setGrupo] = useState("");
    const [restoredPageIndex, setRestoredPageIndex] = useState(0);
    const tableRef = useRef();

    let listEntities = [
        { grupo: "Inmuebles", subgrupo: "Obras", tipo: "TipoObraSuperficie", editable: true },
        { grupo: "Inmuebles", subgrupo: "Obras", tipo: "DestinoSuperficie", editable: true },
        { grupo: "Inmuebles", subgrupo: "Obras", tipo: "TipoObra", editable: true },
        { grupo: "Inmuebles", subgrupo: "Obras", tipo: "DestinoObra", editable: true },
        { grupo: "Inmuebles", subgrupo: "Obras", tipo: "FormaPresentacionObra", editable: true },
        { grupo: "Inmuebles", subgrupo: "Obras", tipo: "FormaCalculoObra", editable: true },
        { grupo: "Inmuebles", subgrupo: "EDE", tipo: "FrecuenciaFacturacion", editable: true },
        { grupo: "Inmuebles", subgrupo: "Superficies", tipo: "TipoSuperficie", editable: true },
        { grupo: "Inmuebles", subgrupo: "Superficies", tipo: "GrupoSuperficie", editable: true },
        { grupo: "Inmuebles", subgrupo: "Lados del Terreno", tipo: "TipoLado", editable: false },
        { grupo: "Vehículos", subgrupo: "Vehículo", tipo: "MotivoBajaVehiculo", editable: true },
        { grupo: "Vehículos", subgrupo: "Vehículo", tipo: "OrigenFabricacion", editable: true },
        { grupo: "Vehículos", subgrupo: "Vehículo", tipo: "Combustible", editable: true },
        { grupo: "Vehículos", subgrupo: "Vehículo", tipo: "FinalidadVehiculo", editable: true },
        { grupo: "Cementerios", subgrupo: "Cementerios", tipo: "TipoConstruccionFuneraria", editable: false },
        { grupo: "Cementerios", subgrupo: "Inhumados", tipo: "Cocheria", editable: true },
        { grupo: "Cementerios", subgrupo: "Inhumados", tipo: "RegistroCivil", editable: true },
        { grupo: "Cementerios", subgrupo: "Inhumados", tipo: "MotivoFallecimiento", editable: true },
        { grupo: "Cementerios", subgrupo: "Inhumados", tipo: "TipoOrigenInhumacion", editable: true },
        { grupo: "Cementerios", subgrupo: "Inhumados", tipo: "TipoDestinoInhumacion", editable: true },
        { grupo: "Cementerios", subgrupo: "Inhumados", tipo: "EstadoInhumacion", editable: true },
        { grupo: "Cementerios", subgrupo: "Inhumados", tipo: "Cementerio", editable: true },
        { grupo: "Comercios", subgrupo: "Inspecciones", tipo: "MotivoInspeccion", editable: true },
        { grupo: "Comercios", subgrupo: "Verificaciones", tipo: "ResultadoVerificacion", editable: true },
        { grupo: "Certificados de Escribanos", subgrupo: "Certificados de Escribanos", tipo: "TipoCertificado", editable: true },
        { grupo: "Legal", subgrupo: "Plantillas Documentos", tipo: "TipoPlantillaDocumento", editable: true },
        { grupo: "Legal", subgrupo: "Certificados", tipo: "InspeccionCertificadoApremio", editable: true },
        { grupo: "Legal", subgrupo: "Apremio", tipo: "TipoCitacion", editable: true },
        { grupo: "Sub Tasas", subgrupo: "Imputaciones", tipo: "TipoCuota", editable: true },
        { grupo: "Inmuebles", subgrupo: "Personas vinculadas", tipo: "TipoVinculoInmueble", editable: false },
        { grupo: "Comercios", subgrupo: "Personas vinculadas", tipo: "TipoVinculoComercio", editable: false },
        { grupo: "Vehículos", subgrupo: "Personas vinculadas", tipo: "TipoVinculoVehiculo", editable: false },
        { grupo: "Cementerios", subgrupo: "Personas vinculadas", tipo: "TipoVinculoCementerio", editable: false },
        { grupo: "Fondeaderos", subgrupo: "Personas vinculadas", tipo: "TipoVinculoFondeadero", editable: false },
        { grupo: "Cuentas Especiales", subgrupo: "Personas vinculadas", tipo: "TipoVinculoEspecial", editable: false },
        { grupo: "Facturación", subgrupo: "Aprobaciones", tipo: "Ordenamiento", editable: false },
        { grupo: "Facturación", subgrupo: "Aprobaciones", tipo: "OrdenamientoGeneral", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "BoletaDefinicion", editable: true },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "BoletaDefinicionSeccion", editable: true },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "TipoVariable", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "CategoriaFuncion", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "Numeracion", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "EstadoEmisionDefinicion", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "TipoEmisionCalculo", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "EstadoEmisionEjecucion", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "EstadoEmisionEjecucionCuenta", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "EstadoEmisionCalculoResultado", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "EstadoEmisionConceptoResultado", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "EstadoEmisionCuentaCorrienteResultado", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "EstadoEmisionImputacionContableResultado", editable: false },
        { grupo: "Cuenta Corriente", subgrupo: "Cuenta Corriente", tipo: "LugarPago", editable: true },
        { grupo: "Cuenta Corriente", subgrupo: "Cuenta Corriente", tipo: "TipoValor", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "EmisionProceso", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "EstadoAprobacion", editable: false },
        { grupo: "Facturación", subgrupo: "Emisiones", tipo: "EstadoProceso", editable: false },
        { grupo: "Legal", subgrupo: "Certificados", tipo: "EstadoCertificadoApremio", editable: false },
        { grupo: "Personas", subgrupo: "Personas", tipo: "TipoDocumento", editable: false },
        { grupo: "Tributos", subgrupo: "Valuaciones", tipo: "TipoValuacion", editable: true },
        { grupo: "Tributos", subgrupo: "Tributos", tipo: "EstadoCuenta", editable: false },
        { grupo: "Tributos", subgrupo: "Tributos", tipo: "TipoTributo", editable: false },
        { grupo: "Tributos", subgrupo: "Tributos", tipo: "EstadoCarga", editable: false },
        { grupo: "Tributos", subgrupo: "Tributos", tipo: "Filtro", editable: false },
        { grupo: "Tributos", subgrupo: "Tributos", tipo: "Obra", editable: true },
        { grupo: "Tributos", subgrupo: "Débitos automáticos", tipo: "TipoSolicitudDebitoAutomatico", editable: true },
        { grupo: "Tributos", subgrupo: "Personas vinculadas", tipo: "TipoInstrumento", editable: true },
        { grupo: "Tributos", subgrupo: "Clase de Elemento", tipo: "ClaseElemento", editable: true },
        { grupo: "Tributos", subgrupo: "Tipo de Elemento", tipo: "TipoElemento", editable: true },
        { grupo: "Tributos", subgrupo: "Unidad de Medida", tipo: "UnidadMedida", editable: false },
        { grupo: "Tributos", subgrupo: "Unidad de Valor", tipo: "UnidadValor", editable: false },
        { grupo: "Tributos", subgrupo: "Periodicidad Declaración Jurada", tipo: "PeriodicidadDeclaracionJurada", editable: false },
        { grupo: "Tributos", subgrupo: "Origen Declaración Jurada", tipo: "OrigenDeclaracionJurada", editable: true },
        { grupo: "Tributos", subgrupo: "Tipo Modelo Declaración Jurada", tipo: "TipoModeloDeclaracionJurada", editable: true },
        { grupo: "Tributos", subgrupo: "Modelo Declaración Jurada", tipo: "ModeloDeclaracionJurada", editable: true },
        { grupo: "Tributos", subgrupo: "Clase Declaración Jurada", tipo: "ClaseDeclaracionJurada", editable: true },
        { grupo: "Tributos", subgrupo: "Tipo Declaración Jurada", tipo: "TipoDeclaracionJurada", editable: true },
        { grupo: "Tributos", subgrupo: "Bloqueo Emisión", tipo: "BloqueoEmision", editable: true },
        { grupo: "Vehículos", subgrupo: "Vehículos", tipo: "TipoVehiculo", editable: true },
        { grupo: "Comercios", subgrupo: "Comercios", tipo: "RubroLiquidacion", editable: true },
        { grupo: "Comercios", subgrupo: "Comercios", tipo: "ZonaTarifaria", editable: true },
        { grupo: "Comercios", subgrupo: "Comercios", tipo: "TipoUbicacion", editable: false },
        { grupo: "Comercios", subgrupo: "Rubros", tipo: "RubroProvincia", editable: true },
        { grupo: "Comercios", subgrupo: "Rubros", tipo: "RubroBCRA", editable: true },
        { grupo: "Comercios", subgrupo: "Rubros", tipo: "MotivoBajaRubroComercio", editable: true },
        { grupo: "Comercios", subgrupo: "Rubros", tipo: "UbicacionComercio", editable: true },
        { grupo: "Comercios", subgrupo: "Rubros", tipo: "TipoAnuncio", editable: true },
        { grupo: "Comercios", subgrupo: "Cartel", tipo: "TipoCartel", editable: true },
        { grupo: "Comercios", subgrupo: "Comercios", tipo: "MotivoBajaComercio", editable: true },
        { grupo: "Certificados de Escribanos", subgrupo: "Certificados de Escribanos", tipo: "ObjetoCertificado", editable: true },
        { grupo: "Certificados de Escribanos", subgrupo: "Certificados de Escribanos", tipo: "Escribano", editable: true },
        { grupo: "Facturación", subgrupo: "Facturación", tipo: "CategoriaTasa", path: "/entidades/categorias-tasas", editable: true },
        { grupo: "Facturación", subgrupo: "Facturación", tipo: "TipoMovimiento", path: "/entidades/tipo-movimientos", editable: true },
        { grupo: "Tributos", subgrupo: "Tributos", tipo: "Controlador", path: "/entidades/controladores", editable: true },
        { grupo: "Tributos", subgrupo: "Tributos", tipo: "TipoControlador", path: "/entidades/tipo-controladores", editable: true },
        { grupo: "Tributos", subgrupo: "Tributos", tipo: "TipoCondicionEspecial", path: "/entidades/tipo-condiciones-especiales", editable: true },
        { grupo: "Tributos", subgrupo: "Tributos", tipo: "TipoRecargoDescuento", path: "/entidades/tipo-recargos-descuentos", editable: true },
        { grupo: "Tributos", subgrupo: "Tributos", tipo: "TipoMulta", path: "/entidades/tipos-multas", editable: true },
        { grupo: "Comercios", subgrupo: "Comercios", tipo: "TipoArrendamiento", path: "/entidades/tipos-arrendamientos", editable: true },
        { grupo: "Vehículos", subgrupo: "Vehículos", tipo: "IncisoVehiculo", path: "/entidades/inciso-vehiculos", editable: true },
        { grupo: "Vehículos", subgrupo: "Vehículos", tipo: "CategoriaVehiculo", path: "/entidades/categorias-vehiculos", editable: true },
        { grupo: "Comercios", subgrupo: "Comercios", tipo: "CategoriaUbicacion", path: "/entidades/categorias-ubicaciones", editable: true },
        { grupo: "Legal", subgrupo: "Legal", tipo: "OrganoJudicial", path: "/entidades/organos-judiciales", editable: true },
        { grupo: "Legal", subgrupo: "Legal", tipo: "TipoActoProcesal", path: "/entidades/tipos-actos-procesales", editable: true },
        { grupo: "Legal", subgrupo: "Legal", tipo: "TipoRelacionCertificadoPersona", path: "/entidades/tipo-relacion-certificado-apremio-persona", editable: true },
        { grupo: "General", subgrupo: "General", tipo: "TipoProceso", editable: false },
        { grupo: "General", subgrupo: "General", tipo: "CategoriaArchivo", editable: true },
    ];

    const [hasEditAccess, setHasEditAccess] = useState(false)
    useAccess({
        key: 'EntidadesView',
        onLoaded: (data, isSuccess, error) => {
            if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error)
            else setHasEditAccess(data.some(x => x.codigo === 'listas_ingresos_publicos_edit'))
        }
    });

    useEffect(() => {
        if (navigationType === 'PUSH' && location.state?.filters) {
            const savedFilters = location.state.filters;
            if (savedFilters.grupo !== undefined) {
                setGrupo(savedFilters.grupo);
            }
            if (typeof savedFilters.pageIndex === 'number') {
                setRestoredPageIndex(savedFilters.pageIndex);
            }
            if (savedFilters.globalFilter && tableRef.current?.setGlobalFilter) {
                tableRef.current.setGlobalFilter(savedFilters.globalFilter);
            }
        }
    }, [location, navigationType]);

    const mount = () => {

        SearchEntidadDefinicion();
        
        const unmount = () => {}
        return unmount;
    }
    useEffect(mount, []);

    //definiciones
    // Acciones (Ver / Editar)
    const cellVMR = (props) => {
        const entidad = props.row.original;
        return (
            <div className='action'>
                <div onClick={() => handleClickEntidadView(entidad)} className="link">
                    <span className="material-symbols-outlined" title="Ver">search</span>
                </div>
                {hasEditAccess && entidad.editable && (
                    <div onClick={() => handleClickEntidadEdit(entidad)} className="link">
                        <span className="material-symbols-outlined" title="Modificar">stylus</span>
                    </div>
                )}
            </div>
        );
    }
    
    const tableColumns = [
        { Header: 'Grupo', accessor: 'grupo', width: '25%' },
        { Header: 'Sub grupo', accessor: 'subgrupo', width: '25%' },
        { Header: 'Lista', accessor: 'descripcion', width: '45%' }, 
        { Header: '', Cell: cellVMR, id:'abm', accessor: 'tipo', width: '5%', disableGlobalFilter: true, disableSortBy: true }
    ];

    const getCurrentFilters = useCallback(() => {
        const currentPageIndex = tableRef?.current?.pageIndex ?? 0;
        const globalFilter = tableRef?.current?.globalFilter ?? '';
        return {
            grupo: grupo,
            pageIndex: currentPageIndex,
            globalFilter: globalFilter
        };
    }, [grupo, tableRef]);

    //handles
    const handleClickEntidadView = (entidad) => {
        const filters = getCurrentFilters();
        if (entidad.path) {
            navigate({ to: `${entidad.path}?mode=${OPERATION_MODE.VIEW}`, options: { state: { filters } } });
        } else {
            navigate({ to: "../entidad/" + OPERATION_MODE.VIEW + "/" + entidad.tipo, options: { state: { filters } } });
        }
    }
    const handleClickEntidadEdit = (entidad) => {
        const filters = getCurrentFilters();
        if (entidad.path) {
            navigate({ to: `${entidad.path}?mode=${OPERATION_MODE.EDIT}`, options: { state: { filters } } });
        } else {
            navigate({ to: "../entidad/" + OPERATION_MODE.EDIT + "/" + entidad.tipo, options: { state: { filters } } });
        }
    }

    //callbacks
    const callbackNoSuccess = (response) => {
        response.json()
        .then((error) => {
            const message = error.message;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
            return {...prevState, loading: false};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    }
    const callbackError = (error) => {
        const message = 'Error procesando solicitud: ' + error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
            return {...prevState, loading: false};
        });
    }

    //funciones
    function SearchEntidadDefinicion() {

        setState(prevState => {
            return {...prevState, loading: true};
        });
    
        const callbackSuccess = (response) => {
            response.json()
            .then((definiciones) => {               
                setState(prevState => {
                    return {...prevState, loading: false};
                });

                for (let i=0; i < listEntities.length; i++) {
                    let entidad = listEntities[i];
                    const definicion = definiciones.find(f => f.tipo === entidad.tipo);
                    entidad.descripcion = (definicion) ? definicion.descripcion : GetTitleFromField(entidad.tipo);
                }
                listEntities.sort((a,b) => a.grupo.localeCompare(b.grupo));
                setState({list: listEntities});
            })
            .catch((error) => {
                const message = 'Error procesando respuesta: ' + error;
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
                setState(prevState => {
                    return {...prevState, loading: false};
                });
            });
        };
    
        const paramsUrl = `/definicion`;
    
        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.ENTIDAD,
            paramsUrl,
            null,
            callbackSuccess,
            callbackNoSuccess,
            callbackError
        );
    
    }


    return (
    <>

        <SectionHeading titles={[{ title: 'Entidades' }, { title: 'Administración de listas' }]} />

        <section className='section-accordion'>

            <div className='grupo'>
                <div className="col-12">
                    <div className='accordion-header'>
                        <div className='row'>
                            <div className="col-12">
                                <div className='accordion-header-title m-left-20'>
                                    <span className='active'>Filtro por grupo</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='accordion-body'>
                        <div className='row'>
                            <div className="col-3">
                            <label htmlFor="grupo" className="form-label">Grupo</label>
                            <Select
                                name="grupo"
                                className="form-control"
                                value={grupo}
                                options={[{ value: '', label: 'Todos' }, ...DistinctArray(state.list.map(x => x.grupo)).map(grupo => ({ value: grupo, label: grupo }))]}
                                onChange={({ target }) => {
                                    setGrupo(target.value);
                                    setRestoredPageIndex(0);
                                    if (tableRef.current?.gotoPage) {
                                        tableRef.current.gotoPage(0);
                                    }
                                    if (tableRef.current?.setGlobalFilter) {
                                        tableRef.current.setGlobalFilter('');
                                    }
                                }}
                            />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="m-top-20">

                <TableCustom
                    ref={tableRef}
                    className={'TableCustomBase'}
                    columns={tableColumns}
                    data={state.list.filter(f => f.grupo.indexOf(grupo) >= 0)}
                    restoredPageIndex={restoredPageIndex}
                />

            </div>

        </section>
        
    </>
    )
}

export default EntidadesView;
